import dayjs from "dayjs";
import { BenchmarkLiquidityGraphParams, QuickViewQueries, ReportsQueries } from "store/types";

export const staticReportsQueries: ReportsQueries = {
  use_accounting_date: false,
  filters: {},
  groupBy: [["assetClass"], ["none"]],
  groupByGraph: null,
  columnType: "stacked",
  columnBy: "measure",
  rowBy: "deal",
  measures: ["Commitment"],
  secondaryPricing: [],
  classicTableColumns: [
    { aggregation: "Adjusted NAV", key: "adjNav", dateRange: { value: "fromInception" } },
    { aggregation: "IRR", key: "irr", dateRange: { value: "ytd" } },
    { aggregation: "IRR", key: "irr-dup", dateRange: { value: "fromInception" } }
  ],
  reportTableColumns: [],
  benchmarkTableColumns: [],
  benchmarkIndexName: null,
  characteristics: [],
  calculatedFields: ["IRR", "Unfunded Commitment"],
  comparisonColumns: ["actual", "planned"],
  currency: "USD",
  exchangeMethod: "toDate",
  originalCurrency: false,
  dateRange: {
    // value: "ytd",
    // from: new Date(new Date().getFullYear() + "-01-01"),
    value: "fromInception",
    to: dayjs().toISOString()
  },
  secondaryDateRange: {
    value: "ytd",
    from: dayjs(new Date().getFullYear() + "-01-01").toISOString(),
    to: dayjs().toISOString()
  },
  graphDataFormation: {}, //we receive this from server,
  cubicSnapshot: {},
  cubicDeal: {},
  cubicBenchmark: {},
  cubicDashboard: {},
  cubicDealDashboard: {},
  cubicCashflow: {
    cubic1: { title: "All Deals", filter: "All Deals" },
    cubic2: { title: "MOIC", filter: "MOIC" },
    cubic3: { title: "IRR", filter: "IRR" },
    cubic4: { title: "DPI", filter: "DPI" },
    cubic5: { title: "Unfunded Commitment", filter: "unfundedCommitment" }
  },
  // cubicSnapshot: {
  //   ["cubic1"]: { title: "All Deals", filter: "All Deals" },
  //   ["cubic2"]: { title: "MOIC", filter: "MOIC" },
  //   ["cubic3"]: { title: "IRR", filter: "IRR" },
  //   ["cubic4"]: { title: "DPI", filter: "DPI" },
  //   ["cubic5"]: { title: "Unfunded Commitment", filter: "unfundedCommitment" }
  // },
  // cubicDeal: {
  //   ["cubic1"]: { title: "Adjusted NAV", filter: "Adjusted NAV" },
  //   ["cubic2"]: { title: "Unfunded Commitment", filter: "Unfunded Commitment" },
  //   ["cubic3"]: { title: "IRR", filter: "IRR" },
  //   ["cubic4"]: { title: "MOIC", filter: "MOIC" },
  //   ["cubic5"]: { title: "DPI", filter: "DPI" }
  // },
  // cubicBenchmark: {
  //   ["cubic1"]: { title: "Adjusted NAV", filter: "Adjusted NAV" },
  //   ["cubic2"]: { title: "Unfunded Commitment", filter: "Unfunded Commitment" },
  //   ["cubic3"]: { title: "IRR", filter: "IRR" },
  //   ["cubic4"]: { title: "MOIC", filter: "MOIC" },
  //   ["cubic5"]: { title: "DPI", filter: "DPI" }
  // },
  // cubicDashboard: {
  //   ["cubic1"]: { title: "Adjusted NAV", filter: "Adjusted NAV" },
  //   ["cubic2"]: { title: "Unfunded Commitment", filter: "Unfunded Commitment" },
  //   ["cubic3"]: { title: "IRR", filter: "IRR" },
  //   ["cubic4"]: { title: "MOIC", filter: "MOIC" }
  // },
  filteredPortfolio: false,
  dealTableRowBy: "investor",
  dealTableGroupBy: [["date"], ["measure"]],
  dealTableColumnBy: "investor",
  mainParameter: ["Adjusted NAV"],
  secondaryParameter: ["IRR"],
  interval: "quarter",
  cumulative: false,
  cashflowSetId: null,
  graphBenchmark: {} as BenchmarkLiquidityGraphParams
};
// staticReportsQueries.reportTableColumns = syncReportTableColumn(staticReportsQueries, []);

export const calcFieldsToDisplay = ["IRR", "MOIC", "DPI", "PME"];

export const defaultQuickViewQueries: QuickViewQueries = {
  filters: {},
  columns: {
    calculatedFields: [],
    characteristics: [],
    measures: [],
    visibleSystemColumns: ["investor", "round", "last_update"],
    columnsOrder: []
  },
  groupByDeal: true
};

export const indexNames: Record<string, string> = {
  "^SPX": "S&P 500",
  "^IXIC": "Nasdaq",
  "^RUT": "Russell 2000",
  "^URTH": "MSCI World",
  "^HYG": "High Yield Corporate",
  "^IGF": "Developed Market Infrastructure",
  "^STOXX": "STOXX Europe 600",
  "^EMCLOUD": "BVP Cloud Index",
  "^TA125": "Tel-Aviv 125",
  "^TELBOND60": "Tel-Bond 60",
  "^TELREAL": "Tel-Aviv Real Estate",
  "^990100-USD-STRD": "MSCI World GTR"
};
export const ALTIUS_BENCHMARK_ID = "altius-benchmark";
export const MIN_BENCHMARK_BAR_WIDTH_PX = 60;

export const DEAL_INDEX = "__deal__";
